module.exports = __webpack_public_path__ + "img/banner3.127b319b.jpg";